import { oz } from '@weft/utils';
import { ApiDateSchema } from './api-date-schema';

export const PeriodSchema = oz.object({
  startTime: ApiDateSchema,
  endTime: ApiDateSchema,
}).refine(data => (data.endTime.valueOf() >= data.startTime.valueOf()), {
  message: 'Start date must be before or equals to end date',
  path: ['startTime'],
}).openapi('Period');

export type Period = oz.infer<typeof PeriodSchema>;